import React from 'react';
import { Box, Container, Typography, Grid, Paper, Avatar, Divider } from '@mui/material';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';

const AboutPage = () => {
  return (
    <Box sx={{ pt: 12, pb: 10 }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography variant="h3" component="h1" gutterBottom>
            About roamzap
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 800, mx: 'auto' }}>
            Your AI-powered travel companion for creating personalized vacation experiences
          </Typography>
        </Box>

        <Paper elevation={2} sx={{ p: 4, mb: 6, borderRadius: 2 }}>
          <Typography variant="h4" gutterBottom>
            Our Mission
          </Typography>
          <Typography variant="body1" paragraph>
            At roamzap, we believe that every journey should be as unique as the traveler. Our mission is to harness the power of artificial intelligence to create personalized travel experiences that match your interests, preferences, and travel style.
          </Typography>
          <Typography variant="body1" paragraph>
            We understand that planning a trip can be overwhelming with countless options and decisions to make. That's why we've developed an intelligent travel assistant that takes the stress out of planning, allowing you to focus on what matters most – creating unforgettable memories.
          </Typography>
          <Typography variant="body1">
            Whether you're a solo adventurer, a couple seeking romance, or a family looking for fun activities, roamzap crafts detailed itineraries tailored specifically to you.
          </Typography>
        </Paper>

        <Grid container spacing={4} sx={{ mb: 6 }}>
          <Grid item xs={12} md={6}>
            <Paper elevation={2} sx={{ p: 4, height: '100%', borderRadius: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Avatar sx={{ bgcolor: 'primary.main', mr: 2 }}>
                  <FlightTakeoffIcon />
                </Avatar>
                <Typography variant="h5">How It Works</Typography>
              </Box>
              <Divider sx={{ mb: 3 }} />
              <Typography variant="body1" paragraph>
                1. <strong>Tell us about your trip</strong> - Enter your destination, travel dates, and group size.
              </Typography>
              <Typography variant="body1" paragraph>
                2. <strong>Share your interests</strong> - Let us know what you enjoy, whether it's history, food, adventure, or relaxation.
              </Typography>
              <Typography variant="body1" paragraph>
                3. <strong>Get your personalized itinerary</strong> - Our AI analyzes thousands of possibilities to create the perfect day-by-day plan.
              </Typography>
              <Typography variant="body1">
                4. <strong>Customize as needed</strong> - Your itinerary is flexible and can be adjusted to your preferences.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper elevation={2} sx={{ p: 4, height: '100%', borderRadius: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Avatar sx={{ bgcolor: 'primary.main', mr: 2 }}>
                  <FlightTakeoffIcon />
                </Avatar>
                <Typography variant="h5">Why Choose roamzap</Typography>
              </Box>
              <Divider sx={{ mb: 3 }} />
              <Typography variant="body1" paragraph>
                <strong>Personalization</strong> - No generic itineraries. Every recommendation is based on your unique preferences.
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Time-saving</strong> - What would take hours of research is completed in seconds.
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Local insights</strong> - Discover hidden gems and authentic experiences beyond the typical tourist spots.
              </Typography>
              <Typography variant="body1">
                <strong>Stress-free planning</strong> - Let our AI handle the complex logistics of trip planning.
              </Typography>
            </Paper>
          </Grid>
        </Grid>


      </Container>
    </Box>
  );
};

export default AboutPage; 